var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilitiesMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 7",
    clipPath: "url(#clip0_373_25431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5665 1.28529C8.99683 0.984049 9.49891 0.833374 10.0002 0.833374C10.5014 0.833374 11.0035 0.984049 11.4338 1.28529L18.1005 5.95196C18.7688 6.41978 19.1668 7.18426 19.1668 8.00004V16.6667C19.1668 18.0474 18.0476 19.1667 16.6668 19.1667H3.3335C1.95279 19.1667 0.833496 18.0474 0.833496 16.6667V8.00004C0.833496 7.18426 1.23153 6.41978 1.89984 5.95196L8.5665 1.28529ZM17.1447 7.31735C17.3675 7.47329 17.5002 7.72812 17.5002 8.00004V16.6667C17.5002 17.127 17.1271 17.5 16.6668 17.5H13.3335V15C13.3335 13.6193 12.2142 12.5 10.8335 12.5H9.16683C7.78612 12.5 6.66683 13.6193 6.66683 15V17.5H3.3335C2.87326 17.5 2.50016 17.127 2.50016 16.6667V8.00004C2.50016 7.72812 2.63284 7.47329 2.85561 7.31735L9.52225 2.65068C9.66583 2.55022 9.83258 2.50004 10.0002 2.50004C10.1677 2.50004 10.3345 2.55022 10.4781 2.65068L17.1447 7.31735ZM11.6668 15V17.5H8.3335V15C8.3335 14.5398 8.70658 14.1667 9.16683 14.1667H10.8335C11.2937 14.1667 11.6668 14.5398 11.6668 15ZM10.4168 5.83337C10.6469 5.83337 10.8335 6.01992 10.8335 6.25004V7.50004H12.0835C12.3136 7.50004 12.5002 7.68659 12.5002 7.91671V8.75004C12.5002 8.98012 12.3136 9.16671 12.0835 9.16671H10.8335V10.4167C10.8335 10.6468 10.6469 10.8334 10.4168 10.8334H9.5835C9.35341 10.8334 9.16683 10.6468 9.16683 10.4167V9.16671H7.91683C7.68671 9.16671 7.50016 8.98012 7.50016 8.75004V7.91671C7.50016 7.68659 7.68671 7.50004 7.91683 7.50004H9.16683V6.25004C9.16683 6.01992 9.35341 5.83337 9.5835 5.83337H10.4168Z",
    fill: "#C7CBD4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_25431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilitiesMenu);
export default __webpack_public_path__ + "static/media/FacilitiesMenu.26a82fc2ee59e329d4a8eb210cdd7d7c.svg";
export { ForwardRef as ReactComponent };